export * from './crm-storage-view.component'